// extracted by mini-css-extract-plugin
export default {"uploadContainer":"style_uploadContainer__m-S+8","removeText":"style_removeText__mM21Q"};